import { memo } from 'react'

import { Loading } from '@corabank/arco'

import * as Styled from './styles'

const PageLoading = (): JSX.Element => (
  <Styled.PageLoading data-testid="page-loading">
    <Loading size="small" />
  </Styled.PageLoading>
)

export default memo(PageLoading)
